export const TIME_FORMAT = 'h:mm a';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_2 = 'M/D/YYYY';
export const DISPLAY_DATE_FORMAT = 'MMM D';
export const DISPLAY_DATE_FORMAT_WITH_YEAR = 'MMM D, YYYY';
export const DISPLAY_DATE_FORMAT_UNABRIDGED = 'MMMM D, YYYY';
export const DISPLAY_SHORT_DATE_FORMAT = 'MMM Do';
export const TIME_LONG_TIME_FORMAT = 'LT';
